import React from 'react'

const Footer = () => {
    return (
        <footer >
            <div className="footer-content">
                <h2>Skill Match</h2>
                <p>Made by Shuyi Yu & Joyce Lee</p>
            </div>
        </footer>
    )
}

export default Footer
